import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { getFirebaseDb, isFirebaseConfigured } from "./firebaseApp";

const requireDb = () => {
	const db = getFirebaseDb();
	if (!isFirebaseConfigured || !db) {
		throw new Error("Firestore is not configured. Add Firebase environment variables first.");
	}
	return db;
};

const encodePath = (path = []) => path.map(([col, row]) => ({ col, row }));

const decodePath = (path = []) => path.map((point) => {
	if (Array.isArray(point)) return point;
	return [point?.col ?? 0, point?.row ?? 0];
});

const encodeMapDef = (mapDef) => {
	if (!mapDef) return mapDef;
	return {
		...mapDef,
		path: Array.isArray(mapDef.path) ? encodePath(mapDef.path) : [],
	};
};

const decodeMapDef = (mapDef) => {
	if (!mapDef) return mapDef;
	return {
		...mapDef,
		path: Array.isArray(mapDef.path) ? decodePath(mapDef.path) : [],
	};
};

const encodeCloudPayload = (payload) => {
	if (!payload) return payload;
	return {
		...payload,
		runState: payload.runState
			? {
				...payload.runState,
				mapDef: encodeMapDef(payload.runState.mapDef),
			}
			: payload.runState,
	};
};

const decodeCloudPayload = (payload) => {
	if (!payload) return payload;
	return {
		...payload,
		runState: payload.runState
			? {
				...payload.runState,
				mapDef: decodeMapDef(payload.runState.mapDef),
			}
			: payload.runState,
	};
};

export const saveCloudPayload = async (uid, payload) => {
	const db = requireDb();
	const profileRef = doc(db, "players", uid);
	const saveRef = doc(db, "players", uid, "saves", "main");
	const encodedPayload = encodeCloudPayload(payload);

	await setDoc(profileRef, {
		...(encodedPayload.profile || {}),
		uid,
		updatedAt: serverTimestamp(),
	}, { merge: true });

	await setDoc(saveRef, {
		...encodedPayload,
		ownerUid: uid,
		updatedAt: serverTimestamp(),
	}, { merge: true });
};

export const loadCloudPayload = async (uid) => {
	const db = requireDb();
	const saveRef = doc(db, "players", uid, "saves", "main");
	const snapshot = await getDoc(saveRef);

	return snapshot.exists() ? decodeCloudPayload(snapshot.data()) : null;
};

export const clearCloudPayload = async (uid) => {
	if (!uid) return;
	const db = requireDb();
	const saveRef = doc(db, "players", uid, "saves", "main");
	await setDoc(saveRef, {
		ownerUid: uid,
		runState: null,
		progress: null,
		settings: null,
		clearedAt: serverTimestamp(),
		updatedAt: serverTimestamp(),
	}, { merge: false });
};
